/**
 * All components that only depend on styled-components come here.
 *
 * Any components that depends on "Antd" should go into `components/antd`
 */
export * from './Heading';
export * from './Logo';



// WEBPACK FOOTER //
// ./app/components/common/index.tsx